import { parse, parseISO } from 'date-fns';
import { formatDateCustom } from '@mc/react-format';

export function stringInputParseDate(date: string) {
  const r = date.trim();
  if (r === '') {
    return null;
  }
  let res: boolean | Date = false;
  for (let format of ['ddMMyyyy', 'dd.MM.yyyy', 'dd. MM. yyyy']) {
    const parsed = parse(r, format, new Date());
    if (parsed instanceof Date && !isNaN(parsed as any)) {
      res = parsed;
      break;
    }
  }
  return res;
}

export function stringInputParseDateTime(date: string) {
  const r = date.trim();
  if (r === '') {
    return null;
  }
  let res: boolean | Date = false;
  for (let format of [
    'ddMMyyyy',
    'dd.MM.yyyy',
    'dd. MM. yyyy',
    'dd.MM.yyyy HH',
    'dd. MM. yyyy HH',
    'dd.MM.yyyy HH:mm',
    'dd. MM. yyyy HH:mm',
  ]) {
    const parsed = parse(r, format, new Date());
    if (parsed instanceof Date && !isNaN(parsed as any)) {
      res = parsed;
      break;
    }
  }
  return res;
}

export function stringInputFormatDate(date: Date, showDay?: boolean) {
  if (date === null || date === undefined) {
    return null;
  }
  return date
    ? formatDateCustom(date, {
        timeFormat: undefined,
        dateFormat: 'long',
        showDay: showDay,
      })
    : null;
}

export function stringInputFormatDateTime(date: Date, showDay?: boolean) {
  if (date === null || date === undefined) {
    return null;
  }
  return date
    ? formatDateCustom(date, {
        timeFormat: 'minute',
        dateFormat: 'long',
        showDay: showDay,
      })
    : null;
}

export function stringInputParseMonthDate(date: string, endOfMonth: boolean) {
  const r = date.trim();
  if (r === '') {
    return null;
  }

  const value = r.replace(/\s\s+/g, ' ');

  let res: boolean | Date = false;
  for (let format of [
    'M. yyyy',
    'MM. yyyy',
    'M.yyyy',
    'MM.yyyy',
    'M/yyyy',
    'MM/yyyy',
    'M / yyyy',
    'MM / yyyy',
    'M, yyyy',
    'MM, yyyy',
    'M,yyyy',
    'MM,yyyy',
    'M yyyy',
    'MM yyyyy',
    'Myyyy',
    'MMyyyyy',
    'M. yy',
    'M, yy',
    'M yy',
    'M',
  ]) {
    try {
      let parsed = parse(value, format, new Date());

      if (parsed instanceof Date && !isNaN(parsed as any)) {
        // Rok - krátký formát
        if (parsed.getFullYear() < 100) {
          let century = new Date().getFullYear();
          century = Math.round(century / 100) * 100;
          // console.log('century', century, '->', century + parsed.getFullYear());
          res = new Date(
            century + parsed.getFullYear(),
            parsed.getMonth(),
            parsed.getDay()
          );
        } else {
          res = parsed;
        }

        if (endOfMonth) {
          // Poslední den se dělá jako den 0 následující měsíc 😃
          res = new Date(res.getFullYear(), res.getMonth() + 1, 0);
        } else {
          res = new Date(res.getFullYear(), res.getMonth(), 1);
        }
        break;
      }
    } catch (e) {}
  }
  // console.log('out', res);
  return res;
}

export const isTimeChanged = (timeDate: Date, oldTime?: string) => {
  const oldTimeDate = oldTime ? parseISO(oldTime) : undefined;

  return (
    timeDate.getHours() !== oldTimeDate?.getHours?.() ||
    timeDate.getMinutes() !== oldTimeDate?.getMinutes?.() ||
    timeDate.getSeconds() !== oldTimeDate?.getSeconds?.()
  );
};

export const isDateChanged = (dayDate: Date, oldDay?: string) => {
  const oldDayDate = oldDay ? parseISO(oldDay) : undefined;

  return (
    dayDate.getFullYear() !== oldDayDate?.getFullYear?.() ||
    dayDate.getMonth() !== oldDayDate?.getMonth?.() ||
    dayDate.getDate() !== oldDayDate?.getDate?.()
  );
};
